import { useRef, useState, useEffect } from "react";
import Breadcrumbs from "../../../../components/breadcrumbs/Breadcrumbs";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/store";
import "./Banner.scss";

const Banner = () => {
  const data = useSelector(
    (state: RootState) => state.collegePredictorIntermediate.landingData
  );

  const videoRef = useRef<HTMLVideoElement>(null);
  const breadcrumbs = data?.breadCrumbs?.paths;
  const [videoError, setVideoError] = useState(false);

  // Direct video URL
  const videoUrl =
    "https://cdncollegementor.blob.core.windows.net/mentors/Mentor%20Video.mp4";

  // Ensure video is paused after loading
  useEffect(() => {
    if (videoRef.current) {
      // Ensure the video is paused initially
      videoRef.current.pause();

      // Add event listener to make sure it's paused if it somehow starts playing
      const handleLoadedData = () => {
        if (videoRef.current) {
          videoRef.current.pause();
        }
      };

      videoRef.current.addEventListener("loadeddata", handleLoadedData);

      return () => {
        if (videoRef.current) {
          videoRef.current.removeEventListener("loadeddata", handleLoadedData);
        }
      };
    }
  }, []);

  return (
    <section className="college-predictor-intermediate py-7 lg:py-5 bg-gradient-to-b from-[#EDFCFF] to-[#89C9ED] text-black">
      <div className="container mx-auto flex flex-col gap-4">
        <div className="flex flex-col leading-10">
          <Breadcrumbs
            links={[
              { name: "Home", path: "/" },
              {
                name: breadcrumbs?.[1],
                path: "/college-predictor",
              },
              { name: breadcrumbs?.[2], path: "/" },
            ]}
          />
        </div>
        <div className="flex gap-12 max-lg:flex-col items-center">
          <div className="w-full lg:w-1/2">
            <div className="flex flex-col gap-4">
              <div className="flex flex-col gap-6">
                <h1 className="text-5xl font-bold text-blue leading-[55px]">
                  {data?.bannerInfo?.title}
                </h1>
                <div
                  className="description flex flex-col gap-4"
                  dangerouslySetInnerHTML={{
                    __html: data?.bannerInfo?.description,
                  }}
                />
              </div>
            </div>
          </div>
          <div className="w-full lg:w-1/2">
            <div className="relative w-full h-0 pb-[56.25%] rounded-3xl overflow-hidden shadow-lg">
              {!videoError ? (
                <video
                  ref={videoRef}
                  src={videoUrl}
                  controls
                  preload="auto"
                  className="absolute inset-0 w-full h-full"
                  onError={() => {
                    console.error("Video error occurred");
                    setVideoError(true);
                  }}
                />
              ) : (
                <div className="absolute inset-0 flex items-center justify-center bg-gray-200 text-gray-700 rounded-3xl">
                  <div className="text-center">
                    <p className="mb-2">Video playback unavailable</p>
                    <button
                      className="bg-blue-600 text-white px-4 py-2 rounded"
                      onClick={() => {
                        setVideoError(false);
                        setTimeout(() => {
                          if (videoRef.current) {
                            videoRef.current.load();
                          }
                        }, 100);
                      }}
                    >
                      Retry
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
